module.exports = __webpack_public_path__ + "img/Logo.86964855.png";